import { useMutation } from 'react-query';

// our hooks
import useMutateGetMortechRates from 'hooks/rates/mortech/useMutateGetMortechRates';
import useMutateGetPylonPurchaseRate from 'hooks/rates/pylon/useMutateGetPylonPurchaseRate';
import useMutateGetPylonRefinanceRate from 'hooks/rates/pylon/useMutateGetPylonRefinanceRate';

function useMutateFetchLatestRate() {
	const { mutateAsync: getMortechRates } = useMutateGetMortechRates();
	const { mutateAsync: getPylonPurchaseRate } =
		useMutateGetPylonPurchaseRate();
	const { mutateAsync: getPylonRefinanceRate } =
		useMutateGetPylonRefinanceRate();

	return useMutation(async (rateDetails) => {
		const { loanProduct, offerMode } = rateDetails;
		const isPurchaseMode = offerMode === 'Purchase';
		const isARMProduct = loanProduct && loanProduct.includes('ARM');

		// only mortech offers ARM products
		if (isARMProduct) {
			const mortechRates = await getMortechRates(rateDetails);
			return mortechRates;
		}

		// both mortech and pylon offer fixed products
		const results = await Promise.allSettled([
			getMortechRates(rateDetails),
			isPurchaseMode
				? getPylonPurchaseRate(rateDetails)
				: getPylonRefinanceRate(rateDetails)
		]);

		// Filter successful results and flatten the arrays
		return results
			.filter((result) => result.status === 'fulfilled')
			.map((result) => result.value)
			.flat()
	});
}

export default useMutateFetchLatestRate;
